const mn = '[cynqueModules/clearVuexDataInLocalStorage.ts]'

export function clearVuexDataInLocalStorage() {
  console.debug(`${mn} clearing vuex data in localForage`)
  localStorage.removeItem('vuex')
}
